/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_ip.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input string to an IP value.
 *
 * @example
 * ROW str1 = "1.1.1.1", str2 = "foo"
 * | EVAL ip1 = TO_IP(str1), ip2 = TO_IP(str2)
 * | WHERE CIDR_MATCH(ip1, "1.0.0.0/8")
 *
 * @example
 * ROW s = "1.1.010.1" | EVAL ip = TO_IP(s, {"leading_zeros":"octal"})
 *
 * @example
 * ROW s = "1.1.010.1" | EVAL ip = TO_IP(s, {"leading_zeros":"decimal"})
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_ip',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'ip',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'ip',
    },
    {
      params: [
        {
          name: 'field',
          type: 'ip',
          optional: false,
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'leading_zeros\', values=[reject, octal, decimal], description=\'What to do with leading 0s in IPv4 addresses.\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'ip',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'ip',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'leading_zeros\', values=[reject, octal, decimal], description=\'What to do with leading 0s in IPv4 addresses.\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'ip',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'ip',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'leading_zeros\', values=[reject, octal, decimal], description=\'What to do with leading 0s in IPv4 addresses.\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'ip',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
